// extracted by mini-css-extract-plugin
module.exports = {"component":"_1sPas","liveAgent":"_2V7OV","icon":"GTchR"};